import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import React from "react";
import { Button, Spin } from "antd";
import { useDownoadExcelOrderByClient } from "../../../../hooks/orders/useDownloadExcelOrderByClient.hook";


const TableOrders = (props) => {

    const downloadHook = useDownoadExcelOrderByClient();

    return (
      props.orders.length > 0 ? (
        <TableContainer component={Paper} elevation={3} style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '40%' }}>
                    ORDENES DE {props.orders[0]?.ordersDetail[0]?.productPrice?.client?.name}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '50%' }}>
                    {
                      downloadHook.loading ? 
                      <Spin />
                      :
                      <Button
                        type="primary"
                        onClick={() => {
                          downloadHook.downloadExcel(props.orders[0]?.ordersDetail[0]?.productPrice?.client?.uuid)
                        }}
                      >
                        Descargar excel
                      </Button>
                    }
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.orders?.map((order, index) => (
                <React.Fragment key={index}>
                  <TableRow onClick={() => props.manejarClickFila(order.id)} style={{ cursor: "pointer" }}>
                    <TableCell style={{ backgroundColor: '#f2f2f2' }}>
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", margin: "0px -5px" }}>
                        
                        <span><b>No. orden: {order.id}</b></span>
                        
                        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                          <SearchIcon 
                            style={{ marginLeft: "8px" , marginRight: "25px" , color: "black"}} 
                            onClick={(e) => {
                              e.stopPropagation(); 
                              props.editOrder(order.uuid)
                            }}
                          />
                        </div>

                      </div>
                    </TableCell>
                  </TableRow>
                  {props.filaExpandida === order.id && (
                    <TableRow id={`expanded-row-${order.id}`} style={{ backgroundColor: '#fff' }}>
                      <TableCell colSpan="1">
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <CustomPieChart 
                            onTime={(order.onTime * 100)/order.ordersDetail.length}
                            pending={(order.pending * 100)/order.ordersDetail.length}
                            passTime={(order.passTime * 100)/order.ordersDetail.length}
                          />
                          <div style={{ marginLeft: "15px", fontSize: '12px', marginTop: '15px' }}>
                            <p>
                              <b>Cantidad de productos:</b> {order.ordersDetail.length}
                            </p>
                            
                            <p>
                              <span style={{ backgroundColor: '#ebf3a0', display: 'inline-block', width: '10px', height: '10px', marginRight: '5px' }}></span>
                              <b>Entregas a tiempo:</b> {order.onTime}
                            </p>

                            <p>
                              <span style={{ backgroundColor: '#f9a59a', display: 'inline-block', width: '10px', height: '10px', marginRight: '5px' }}></span>
                              <b>Entregas a destiempo:</b> {order.passTime}
                            </p>

                            <p>
                              <span style={{ backgroundColor: '#f9d99a', display: 'inline-block', width: '10px', height: '10px', marginRight: '5px' }}></span>
                              <b>Entregas pendientes:</b> {order.pending}
                            </p>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}

                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : `No se encuentra informacion con los criterios de busqueda...`
    );
  };

  const CustomPieChart = (props) => {
    const data = [
      { name: 'A tiempo (%) ', value: props.onTime },
      { name: 'Destiempo (%) ', value: props.passTime},
      { name: 'Pendiente (%)', value: props.pending},
    ];
  
    const COLORS = ['#ebf3a0', '#f9a59a','#f9d99a'];
  
    return (
      <PieChart width={100} height={100}>
        <Pie
          dataKey="value"
          data={data}
          cx={50}
          cy={50}
          outerRadius={30}
          fill="#8884d8"
          
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    );
  };

  export default TableOrders;